module.exports = __webpack_public_path__ + "img/rise-1@2x.ba4f1241.png";